import { useQuery } from "@tanstack/react-query";
import { _axios } from "../utils/axios";

// ── Types ────────────────────────────────────────────────────────────────────

export type TCompletedApplication = {
    srNo:          number;
    applicationId: string;
    plotOwnerName: string;
    plotNo:        string;
    mauja:         string;
    khasaraNo:     string;
    plotUsageType: string;
    completedDate: string;
    receiptNo:     string;
    paymentDate:   string;
    totalPayment:  number;
};

export type TCompletedReportFilters = {
    fromDate:      string;
    toDate:        string;
    plotUsageType: string;
};

// ── Query Key Store ───────────────────────────────────────────────────────────

export const completedReportKeyStore = {
    list: (page: number, limit: number, filters: TCompletedReportFilters) => [
        "completed-applications-report",
        page,
        limit,
        filters,
    ],
};

// ── Hook ─────────────────────────────────────────────────────────────────────

export function useCompletedApplicationsReport({
                                                   page,
                                                   limit,
                                                   filters,
                                                   enabled,
                                                   sort,
                                                   sortVal,
                                               }: {
    page: number;
    limit: number;
    filters: TCompletedReportFilters;
    enabled: boolean;
    sort?: string;
    sortVal?: number;
}) {
    return useQuery({
        queryKey: ["completed-applications-report", page, limit, filters, sort, sortVal],
        queryFn:  () =>
            _axios.post<{
                totalPayment: number;
                success: boolean;
                data:    TCompletedApplication[];
                pagination: { page: number; limit: number; hasMore: boolean; total: number };
            }>("/completed-applications-report/list", { page, limit, ...filters, sort, sortVal }),
        enabled,
        staleTime: 2 * 60 * 1000,
        select: (d) => ({
            data:         d.data.data,
            pagination:   d.data.pagination,
            totalPayment: d.data.totalPayment as number,
        }),
    });
}